#import "./mediaSliderDataFragment.gql"
#import "./documentDownloadDataFragment.gql"

query getCatalogCategoryDataById(
  $baseSiteId: BaseSiteId!
  $apiLang: String!
  $categoryId: String!
  $maxHeadings: Int
  $includeLogisticAttributes: Boolean = false
) {
  getCatalogCategoryDataById(baseSiteId: $baseSiteId, apiLang: $apiLang, categoryId: $categoryId) {
    CategoryId
    RootCategory
    Media {
      ...mediaSliderData
    }
    AssemblyMedia {
      Name
      media: filteredMedia(outputType: "PR") {
        Url
        label: getTextListValue(first: true)
        TextList {
          Key
          Value
        }
      }
    }
    Documents {
      AdditionalDocuments {
        ...documentDownloadData
      }
      Approvals {
        DocumentId
        Url
        Name
        Format
        FileSize
        ValidFrom
        ValidTo
        Description
        nr: getAttributeListValue(key: "ZULANR")
        ChildDocumentIds
        ParentDocumentId
        TextList {
          Key
          Value
        }
        Group {
          Value
          GroupRank
          DocumentRank
        }
      }
    }
    TextList {
      Key
      Value
    }
    ProductIds
    description: getTextListValue(key: "DOKBSTMARKDESCR")
    familyLineDrawing
    categoryAttributes: categoryAttributes(
      max: $maxHeadings
      includeLogisticAttributes: $includeLogisticAttributes
    ) {
      AttributeKey
      AttributeName
      TechnicalName
      Unit
    }
    RelatedCategories
    Slug
    SystemComponents
    CategoryDisplayNamePath
    SystemItem
  }
}
